import React from 'react';

const GetSignContactsIcon = (type: string): JSX.Element => {
  switch (type) {
    case '-sharp-outlined':
      return (
        <svg width='6.25rem' height='6.25rem' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <mask id='path-1-inside-1_1044_107' fill='var(--white-color)'>
            <path d='M80 26.4158V90.0696H20V10H63.5842' />
          </mask>
          <path
            d='M80 90.0696V92.0696H82V90.0696H80ZM20 90.0696H18V92.0696H20V90.0696ZM20 10V8H18V10H20ZM78 26.4158V90.0696H82V26.4158H78ZM80 88.0696H20V92.0696H80V88.0696ZM22 90.0696V10H18V90.0696H22ZM20 12H63.5842V8H20V12Z'
            fill='var(--secondary-brand-color)'
            mask='url(#path-1-inside-1_1044_107)'
          />
          <mask id='path-3-inside-2_1044_107' fill='var(--white-color)'>
            <path d='M63.582 10V26.4158H79.9979' />
          </mask>
          <path
            d='M62.8749 10.7071L71.0828 18.915L72.4971 17.5008L64.2891 9.29289L62.8749 10.7071ZM71.0828 18.915L79.2908 27.1229L80.705 25.7087L72.4971 17.5008L71.0828 18.915ZM63.582 26.4158H61.582V28.4158H63.582V26.4158ZM61.582 10V26.4158H65.582V10H61.582ZM63.582 28.4158H79.9979V24.4158H63.582V28.4158Z'
            fill='var(--secondary-brand-color)'
            mask='url(#path-3-inside-2_1044_107)'
          />
          <path
            d='M28.0391 36.2026H70.8403'
            stroke='var(--secondary-brand-color)'
            strokeWidth='2'
            strokeMiterlimit='10'
          />
          <path
            d='M28.0391 44.7629H70.8403'
            stroke='var(--secondary-brand-color)'
            strokeWidth='2'
            strokeMiterlimit='10'
          />
          <path
            d='M28.0391 53.3232H70.8403'
            stroke='var(--secondary-brand-color)'
            strokeWidth='2'
            strokeMiterlimit='10'
          />
          <path
            d='M28.0391 61.8835H70.8403'
            stroke='var(--secondary-brand-color)'
            strokeWidth='2'
            strokeMiterlimit='10'
          />
          <path d='M35.5 82.5V70.5H71.5V82.5H35.5Z' fill='var(--white-color)' stroke='var(--secondary-brand-color)' />
          <path d='M66.3228 73.967L60.9727 79.3172' stroke='var(--secondary-brand-color)' strokeMiterlimit='10' />
          <path
            d='M61.1555 74.3845C61.2997 74.3845 61.4165 74.2677 61.4165 74.1235C61.4165 73.9794 61.2997 73.8625 61.1555 73.8625C61.0114 73.8625 60.8945 73.9794 60.8945 74.1235C60.8945 74.2677 61.0114 74.3845 61.1555 74.3845Z'
            stroke='var(--secondary-brand-color)'
            strokeWidth='2'
            strokeMiterlimit='10'
          />
          <path
            d='M66.218 79.4475C66.3622 79.4475 66.479 79.3307 66.479 79.1865C66.479 79.0424 66.3622 78.9255 66.218 78.9255C66.0739 78.9255 65.957 79.0424 65.957 79.1865C65.957 79.3307 66.0739 79.4475 66.218 79.4475Z'
            stroke='var(--secondary-brand-color)'
            strokeWidth='2'
            strokeMiterlimit='10'
          />
          <path
            d='M40.1719 76.6289H55.9613'
            stroke='var(--secondary-brand-color)'
            strokeWidth='2'
            strokeMiterlimit='10'
          />
          <line x1='64.3536' y1='12.6464' x2='76.3536' y2='24.6464' stroke='var(--secondary-brand-color)' />
          <path d='M70.8388 71.356H36.5195V81.8383H70.8388V71.356Z' fill='var(--white-color)' />
          <path
            d='M47.7695 76.571H67.3694'
            stroke='var(--secondary-brand-color)'
            strokeWidth='2'
            strokeMiterlimit='10'
          />
          <path d='M39.7305 74.1199L44.6891 79.0743' stroke='var(--secondary-brand-color)' strokeMiterlimit='10' />
          <path d='M44.6891 74.1199L39.7305 79.0743' stroke='var(--secondary-brand-color)' strokeMiterlimit='10' />
        </svg>
      );
    case '-rounded-outlined':
      return (
        <svg width='100' height='100' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <mask id='path-1-inside-1_765_4110' fill='var(--white-color)'>
            <path d='M80 26.4158V85.0696C80 87.831 77.7614 90.0696 75 90.0696H25C22.2386 90.0696 20 87.831 20 85.0696V15C20 12.2386 22.2386 10 25 10H63.5842' />
          </mask>
          <path
            d='M82 26.4158C82 25.3113 81.1046 24.4158 80 24.4158C78.8954 24.4158 78 25.3113 78 26.4158H82ZM63.5842 12C64.6887 12 65.5842 11.1046 65.5842 10C65.5842 8.89543 64.6887 8 63.5842 8V12ZM78 26.4158V85.0696H82V26.4158H78ZM75 88.0696H25V92.0696H75V88.0696ZM22 85.0696V15H18V85.0696H22ZM25 12H63.5842V8H25V12ZM22 15C22 13.3431 23.3431 12 25 12V8C21.134 8 18 11.134 18 15H22ZM25 88.0696C23.3431 88.0696 22 86.7264 22 85.0696H18C18 88.9356 21.134 92.0696 25 92.0696V88.0696ZM78 85.0696C78 86.7264 76.6569 88.0696 75 88.0696V92.0696C78.866 92.0696 82 88.9356 82 85.0696H78Z'
            fill='var(--secondary-brand-color)'
            mask='url(#path-1-inside-1_765_4110)'
          />
          <mask id='path-3-inside-2_765_4110' fill='var(--white-color)'>
            <path d='M63.584 10V21.4158C63.584 24.1773 65.8226 26.4158 68.584 26.4158H79.9998' />
          </mask>
          <path
            d='M64.2911 9.29289C63.9006 8.90237 63.2674 8.90237 62.8769 9.29289C62.4864 9.68342 62.4864 10.3166 62.8769 10.7071L64.2911 9.29289ZM79.2927 27.1229C79.6832 27.5135 80.3164 27.5135 80.7069 27.1229C81.0974 26.7324 81.0974 26.0993 80.7069 25.7087L79.2927 27.1229ZM62.8769 10.7071L71.0848 18.915L72.499 17.5008L64.2911 9.29289L62.8769 10.7071ZM71.0848 18.915L79.2927 27.1229L80.7069 25.7087L72.499 17.5008L71.0848 18.915ZM65.584 10C65.584 8.89543 64.6886 8 63.584 8C62.4794 8 61.584 8.89543 61.584 10H65.584ZM79.9998 28.4158C81.1044 28.4158 81.9998 27.5204 81.9998 26.4158C81.9998 25.3113 81.1044 24.4158 79.9998 24.4158V28.4158ZM61.584 10V21.4158H65.584V10H61.584ZM68.584 28.4158H79.9998V24.4158H68.584V28.4158ZM61.584 21.4158C61.584 25.2818 64.718 28.4158 68.584 28.4158V24.4158C66.9271 24.4158 65.584 23.0727 65.584 21.4158H61.584Z'
            fill='var(--secondary-brand-color)'
            mask='url(#path-3-inside-2_765_4110)'
          />
          <path
            d='M28.0371 36.2026H70.8383'
            stroke='var(--secondary-brand-color)'
            strokeWidth='2'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M28.0371 44.7629H70.8383'
            stroke='var(--secondary-brand-color)'
            strokeWidth='2'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M28.0371 53.3232H70.8383'
            stroke='var(--secondary-brand-color)'
            strokeWidth='2'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M28.0371 61.8835H70.8383'
            stroke='var(--secondary-brand-color)'
            strokeWidth='2'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M37 70.5H70C70.8284 70.5 71.5 71.1716 71.5 72V81C71.5 81.8284 70.8284 82.5 70 82.5H37C36.1716 82.5 35.5 81.8284 35.5 81V72C35.5 71.1716 36.1716 70.5 37 70.5Z'
            fill='var(--white-color)'
            stroke='var(--secondary-brand-color)'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M66.3248 73.967L60.9746 79.3172'
            stroke='var(--secondary-brand-color)'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M61.1575 74.3845C61.3016 74.3845 61.4185 74.2677 61.4185 74.1235C61.4185 73.9794 61.3016 73.8625 61.1575 73.8625C61.0133 73.8625 60.8965 73.9794 60.8965 74.1235C60.8965 74.2677 61.0133 74.3845 61.1575 74.3845Z'
            stroke='var(--secondary-brand-color)'
            strokeWidth='2'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M66.22 79.4475C66.3641 79.4475 66.481 79.3307 66.481 79.1865C66.481 79.0424 66.3641 78.9255 66.22 78.9255C66.0758 78.9255 65.959 79.0424 65.959 79.1865C65.959 79.3307 66.0758 79.4475 66.22 79.4475Z'
            stroke='var(--secondary-brand-color)'
            strokeWidth='2'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M40.1738 76.6289H55.9633'
            stroke='var(--secondary-brand-color)'
            strokeWidth='2'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <line
            x1='64.7071'
            y1='13'
            x2='76'
            y2='24.2929'
            stroke='var(--secondary-brand-color)'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M68.8388 71.356H38.5195C37.415 71.356 36.5195 72.2514 36.5195 73.356V79.8383C36.5195 80.9429 37.415 81.8383 38.5195 81.8383H68.8388C69.9434 81.8383 70.8388 80.9429 70.8388 79.8383V73.356C70.8388 72.2514 69.9434 71.356 68.8388 71.356Z'
            fill='var(--white-color)'
          />
          <path
            d='M47.7676 76.571H67.3674'
            stroke='var(--secondary-brand-color)'
            strokeWidth='2'
            strokeMiterlimit='10'
            strokeLinecap='round'
          />
          <path d='M39.7305 74.1199L44.6891 79.0743' stroke='var(--secondary-brand-color)' strokeMiterlimit='10' />
          <path d='M44.6891 74.1199L39.7305 79.0743' stroke='var(--secondary-brand-color)' strokeMiterlimit='10' />
        </svg>
      );
    default: //"-sharp-filled"
      return (
        <svg width='100' height='100' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path d='M80 26.4016V90H20V10H63.5842' fill='var(--tint-brand-color)' />
          <mask id='path-2-inside-1_1035_1643' fill='var(--white-color)'>
            <path d='M63.5859 10V26.4016H80.0018' />
          </mask>
          <path d='M63.5859 10V26.4016H80.0018' fill='var(--primary-brand-color)' />
          <path
            d='M63.5859 26.4016H62.5859V27.4016H63.5859V26.4016ZM62.5859 10V26.4016H64.5859V10H62.5859ZM63.5859 27.4016H80.0018V25.4016H63.5859V27.4016Z'
            fill='var(--primary-brand-color)'
            mask='url(#path-2-inside-1_1035_1643)'
          />
          <path
            d='M28.0391 36.1799H70.8403'
            stroke='var(--secondary-brand-color)'
            strokeWidth='2'
            strokeMiterlimit='10'
          />
          <path
            d='M28.0391 44.7327H70.8403'
            stroke='var(--secondary-brand-color)'
            strokeWidth='2'
            strokeMiterlimit='10'
          />
          <path
            d='M28.0391 53.2856H70.8403'
            stroke='var(--secondary-brand-color)'
            strokeWidth='2'
            strokeMiterlimit='10'
          />
          <path
            d='M28.0391 61.8384H70.8403'
            stroke='var(--secondary-brand-color)'
            strokeWidth='2'
            strokeMiterlimit='10'
          />
          <path d='M70.8388 71.356H36.5195V81.8383H70.8388V71.356Z' fill='var(--white-color)' />
          <path d='M47.7656 76.571H67.3655' stroke='var(--primary-brand-color)' strokeWidth='2' strokeMiterlimit='10' />
          <path d='M39.7305 74.1199L44.6891 79.0743' stroke='var(--secondary-brand-color)' strokeMiterlimit='10' />
          <path d='M44.6891 74.1199L39.7305 79.0743' stroke='var(--secondary-brand-color)' strokeMiterlimit='10' />
        </svg>
      );
  }
};

export default GetSignContactsIcon;
